const SITE_ORIGIN = "https://integrated.social";
const FILE_EXTENSION = /\.[a-z0-9]{2,8}$/i;

/**
 * Returns the single internal link form used by public navigation: lowercase,
 * apex-relative and trailing-slashed before any query string or fragment.
 * External URLs are returned unchanged.
 */
export function canonicalPath(value: string): string {
  if (!value) return "/";

  const isAbsolute = /^https?:\/\//i.test(value);
  let url: URL;
  try {
    url = new URL(value, SITE_ORIGIN);
  } catch {
    return value;
  }

  if (isAbsolute && url.origin !== SITE_ORIGIN) return value;

  // Campaign attribution belongs in analytics, not in crawlable first-party
  // anchors. Retain functional parameters such as score prefill values.
  for (const key of Array.from(url.searchParams.keys())) {
    if (key.toLowerCase().startsWith("utm_")) url.searchParams.delete(key);
  }

  const rawPath = url.pathname.replace(/\/+/g, "/").toLowerCase();
  const path = rawPath === "/" || FILE_EXTENSION.test(rawPath)
    ? rawPath
    : `${rawPath.replace(/\/+$/, "")}/`;

  return `${path || "/"}${url.search}${url.hash}`;
}

/** Builds an absolute canonical URL for schema, metadata and sitemap-adjacent uses. */
export function canonicalUrl(value: string): string {
  return `${SITE_ORIGIN}${canonicalPath(value)}`;
}
